<template>
  <Layout >

      
    <div  class="flex items-center justify-center pt-5 ">
      
       <img class="h-full w-full pt-1 rounded-full" src="../assets/RasFamilie.png" alt="Workflow" />
      </div>
  
    



  </Layout>
</template>

<script>
import Layout from './layouts/Main'
//import { mapGetters } from "vuex";
//import { mapActions } from 'vuex'

//import 'firebaseui/dist/firebaseui.css'



export default {
  name: 'ras',
  components: { Layout,  },
  data() {
    return {
     
      //hello: "",
      //submitted:false,
      
    };
  },
  created(){
    this.userData = this.currentUserData;
    //this.getPages();
   
    
  },
  mounted() {
    //this.getPages();
  
  },
  methods: {
    
    getPages() {
      //const employer = [];
      const employerData = this.$db
        .collection("websitestatus")
        .where("status", "==", "active");

      employerData.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = {
            id: doc.id,
            ...doc.data(),
          };
          this.pages = data;
        });
      });
    },
    toggleMobilemenu() {
      this.mobileOpen = !this.mobileOpen;
    },
    toggleMobilemenu1() {
      this.mobileOpen1 = !this.mobileOpen1;
    },
    toggleMobilemenu2() {
      this.mobileOpen2 = !this.mobileOpen2;
    },
   
    trigger: function() {
      this.error = true
      this.errorMessage = "Whoops!"
    },
    setTab(tab) {
      this.tab = tab;
    },
  
   
    redirect() {
      this.$router.push({
      name: "dashboard",
      });
    },
    Register() {
      this.$router.push({
      name: "register",
      });
    },
    checkForm: function (e) {
      this.errors = [];

        if (!this.email) {
          this.errors.push("Email is required...");
        }
        if (!this.password) {
          this.errors.push("password is required...");
        }
        if (!this.errors.length) {
          return true;
        }

        e.preventDefault();
      },

      checkForm1: function (e) {
      this.errors = [];

       
        if (!this.name) {
          this.errors.push("Name is required...");
        }
       
        if (!this.email) {
          this.errors.push("Email is required...");
        }
        if (!this.email) {
          this.errors.push('Email is required...');
        } else if (!this.validEmail(this.email)) {
          this.errors.push('A Valid Email address is required.');
        }
        if (!this.password) {
          this.errors.push("Password is required...");
        }
        if (!this.errors.length) {
          return true;
        }
        e.preventDefault();
      },
      validEmail: function (email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },    
       
  },
  computed: {
   
      notSamePasswords () {
          if (this.passwordsFilled) {
            return (this.password !== this.checkPassword)
          } else {
            return false
          }
        },
      passwordsFilled () {
        return (this.password !== '' && this.checkPassword !== '')
      },
      passwordValidation () {
        let errors = []
        for (let condition of this.rules) {
          if (!condition.regex.test(this.password)) {
            errors.push(condition.message)
          }
        }
        if (errors.length === 0) {
          return { valid:true, errors }
        } else {
          return { valid:false, errors }
        }
      },
  },
}
</script>
